import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionIntro } from './components/SolutionIntro';
import { TomosGrid } from './components/TomosGrid';
import { BonusesSection } from './components/BonusesSection';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen bg-brand-black selection:bg-brand-pink selection:text-brand-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionIntro data-id="element-6" />
        <TomosGrid data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <Pricing data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
      <StickyMobileCTA data-id="element-13" />
    </div>;
}